

import { useNavigate } from 'react-router-dom';
import { axiosApi as axios } from '../helpers/axiosApi';
import { toaster } from '../helpers/toaster';
import { eraseCookie, getCookie, setCookie } from './helpers';

class Auth {
  constructor() {
    this.authenticated = false;
    this.csrf = null;
  }

  checkToken = (cb) => {
    console.log(getCookie('access'))
    axios.get('/accounts/check-token/', {
      headers: {
        "Authorization": `Bearer ${getCookie('access')}`
      }
    })
    .then(res => {
      if(res.status === 200){
        this.authenticated = true;
        cb(true, res.data.data.usertype)
        // return true;
      }
      else{
        this.authenticated = false;
        cb(false, null)
        // return false;
      }
    })
    .catch((err) => {
      console.log(err);
      cb(false)
    });
  }

  login(credentials, cb) {
    const { email, password } = credentials;

    axios.post("/accounts/login/", {
      email,
      password
    }, {
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": getCookie('csrftoken'),
      },
      credentials: "same-origin",
    })
    .then(res => {
      const {status,data} = res
      // localStorage.setItem('only_attachment', res.data.only_attachment)
      setCookie("access", res.data.access)
      setCookie("refresh", res.data.refresh)
      cb(res.data.data)
      if(status===200){
        toaster(data.message, "success")
      }
      useNavigate("/")
    })
    .catch(error => {
      console.log(error)
      console.log("Hi")
      // if (!error.response) {
      //   toaster("Something went wrong, please try again laterrrrr", "error")
      // }
      // else
      // {
        const {message,code} = error.response.data.errors[0]
        toaster(message, "error")
      // }
    })
  }

  logout(cb) {

    axios.post("/accounts/logout/", {
      refresh: getCookie('refresh') 
    },
       {
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": getCookie('csrftoken'),
        "Authorization": `Bearer ${getCookie('access')}`
      },
    }).then(res => {
      if (cb) {
        this.authenticated = false;
        eraseCookie("access")
        eraseCookie("refresh")
        cb(false);
        toaster("Logout successful", "success")
      }
    })
  }

  isAuthenticated() {
    return this.authenticated;
  }
}

export default new Auth();
